/**
 **@author       yontaek@zumper.com (Yon Taek Chung)
 **@copyright    Copyright (c) 2024, Zumper
 */

import { Box, Flex, Heading, Image, Text } from '@chakra-ui/react'
import { CarouselV3 } from '@zcode-ui/containers'
import { selectIsMobile } from '@zcode-ui/web-zumper-global-state'
import React from 'react'
import { useSelector } from 'react-redux'
import { ProgressDots } from '../ProgressDots/ProgressDots'
import { RENTING_MADE_EASY_CONTENTS } from './constants'

const DesktopContent = () => (
  <Flex
    display="flex"
    gap={{ desktop: '23px', lg: '26px', xl: 'unset' }}
    justifyContent="space-between"
    w="100%"
  >
    {RENTING_MADE_EASY_CONTENTS.map(({ text, subText, icon }) => {
      return (
        <Flex
          minWidth={{ xl: '383px' }}
          width={{ xl: '383px' }}
          alignItems="center"
          flexDir="column"
          px={{ lg: '25.5px', xl: 0 }}
          key={text}
        >
          <Image
            alt=""
            height={{ desktop: '120px', xl: '160px' }}
            loading="eager"
            src={icon}
            width={{ desktop: '210px', xl: '280px' }}
          />
          <Heading<'h3'>
            as="h3"
            margin="32px 0 8px"
            fontSize={{ base: 'md', lg: 'lg' }}
            lineHeight={6}
          >
            {text}
          </Heading>
          <Text color="gray.950" textAlign="center" variant="body16Reg" w={{ xl: '287px' }}>
            {subText}
          </Text>
        </Flex>
      )
    })}
  </Flex>
)

const MobileContent = () => (
  <Box<'div'> display="block" sx={{ 'div div': { overflow: 'visible' } }} w="100%">
    <CarouselV3 isMobile ProgressDots={ProgressDots}>
      {RENTING_MADE_EASY_CONTENTS.map(({ text, subText, icon }) => {
        return (
          <Flex key={text} minWidth="100%" width="100%" alignItems="center" flexDir="column">
            <Image alt="" height="120px" loading="eager" src={icon} width="210px" />
            <Heading<'h3'> as="h3" margin="32px 0 8px" fontSize="20px" lineHeight={6}>
              {text}
            </Heading>
            <Text color="gray.950" textAlign="center" variant="body16Reg" w="280px">
              {subText}
            </Text>
          </Flex>
        )
      })}
    </CarouselV3>
  </Box>
)

export const RentingMadeEasy = () => {
  const isMobile = useSelector(selectIsMobile)

  return (
    <Flex alignItems="center" flexDir="column" marginBottom={{ base: 6, desktop: 'unset' }}>
      <Flex flexDir="column" mb={{ base: 10, lg: 16 }}>
        <Heading<'h2'> as="h2" mb={{ base: 0, lg: 4 }} textAlign="center" variant="display28To32">
          Renting made easy
        </Heading>
        <Text
          color="gray.950"
          display={{ base: 'block' }}
          pt={{ base: '10px', desktop: '0px' }}
          textAlign="center"
          variant="body16Reg"
        >
          Helping millions of renters navigate the rental market with confidence.
        </Text>
      </Flex>
      {isMobile ? <MobileContent /> : <DesktopContent />}
    </Flex>
  )
}
